import { cn } from "~/lib/utils";

interface SessionCardProps {
  icon: React.ComponentType<{ className?: string }>;
  iconClassName?: string;
  borderClassName?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
}

export function SessionCard({
  icon: Icon,
  iconClassName,
  borderClassName,
  title,
  description,
  children,
  footer,
}: SessionCardProps) {
  return (
    <div
      className={cn(
        "w-full rounded-lg bg-secondary p-4 shadow-xs",
        borderClassName ? `border ${borderClassName}` : "border border-border",
      )}
    >
      <div className="flex items-start gap-3">
        <div
          className={cn(
            "flex h-8 w-8 shrink-0 items-center justify-center rounded-full",
            iconClassName ?? "bg-brand/15 text-brand",
          )}
        >
          <Icon className="h-4 w-4" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold">{title}</div>
          {description && (
            <div className="mt-0.5 text-sm text-muted-foreground">
              {description}
            </div>
          )}
        </div>
      </div>
      {children && <div className="mt-3 space-y-3">{children}</div>}
      {footer && <div className="mt-3">{footer}</div>}
    </div>
  );
}
